import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { deepExtend } from "../../Utils/Utils";
export var ManualParticle = /*#__PURE__*/function () {
  function ManualParticle() {
    _classCallCheck(this, ManualParticle);
  }

  _createClass(ManualParticle, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.position) {
        var _data$position$x, _data$position$y, _data$position$mode;

        this.position = {
          x: (_data$position$x = data.position.x) !== null && _data$position$x !== void 0 ? _data$position$x : 50,
          y: (_data$position$y = data.position.y) !== null && _data$position$y !== void 0 ? _data$position$y : 50,
          mode: (_data$position$mode = data.position.mode) !== null && _data$position$mode !== void 0 ? _data$position$mode : "percent"
        };
      }

      if (data.options) {
        this.options = deepExtend({}, data.options);
      }
    }
  }]);

  return ManualParticle;
}();